// extracted by mini-css-extract-plugin
export default {"card":"Card_card__QhZwq","clickable":"Card_clickable__Q9NWE"};